export default "__VITE_ASSET__Q8AW9RRz__"